import { render } from "./ResetProject.vue?vue&type=template&id=3d48e434&scoped=true"
import script from "./ResetProject.vue?vue&type=script&lang=js"
export * from "./ResetProject.vue?vue&type=script&lang=js"

import "./ResetProject.vue?vue&type=style&index=0&id=3d48e434&scoped=true&lang=css"

import exportComponent from "D:\\Repos\\c2stem\\c2stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d48e434"]])

export default __exports__